import React from 'react';

import Sticky from 'react-sticky-el';

import ContactBanner from '../atoms/ContactBanner';
import SubPageTitle from '../molecules/SubPageTitle';
import SideBar from '../organisms/SideBar';

const SubPageLayout = (props) => {
  const { title, children } = props;

  return (
    <>
      <ContactBanner />
      <SubPageTitle title={title} />
      <div>
        <div
          style={{
            position: 'relative',
            width: 1200,
            overflow: 'hidden',
            margin: '20px auto auto',
          }}
          id="subPageBody"
        >
          <div
            style={{
              display: 'inline-block',
              width: '840px',
              float: 'left',
            }}
          >
            {children}
          </div>

          <Sticky boundaryElement="#subPageBody" hideOnBoundaryHit={false}>
            <SideBar style={{ container: { float: 'right' } }} />
          </Sticky>
        </div>
      </div>
    </>
  );
};

export default SubPageLayout;
